<p-dialog [(visible)]="currentDisplay" [modal]="true" [closable]="false" [style]="{width: '80vw'}" class="layer1" [blockScroll]="true" (onHide)="hideDialog()" appendTo="body">
    <ng-template pTemplate="header">
        <div class="w-100">
            <div style="display: flex; justify-content: space-between; width: 100%;">
                <h5 class="p-mb-0">
                    All Activity Lists
                </h5>
                <button pButton pRipple (click)="hideDialog()" class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times"></button>
            </div>
            <div class="header p-grid p-mt-0 p-ai-center">
                <div class="p-col-6 p-p-0">
                    <div style="max-width: 200px;">
                        <p-dropdown [options]="filters" class="panelDD" [(ngModel)]="filterType" optionLabel="name" optionValue="value" (onChange)="getActivityTimeline()" appendTo="body" placeholder="Select Activity">
                        </p-dropdown>
                    </div>
                </div>
                <div class="p-col-6 p-p-0">
                    <span class="p-ml-2 group-by-wrapper">
                        <button icon="pi pi-tags" pButton pRipple type="button" class="p-button-secondary p-button-text"
                                (click)="groupby.toggle($event);showGroupBy()"
                                pTooltip="Group by" tooltipPosition="top">
                        </button>
                        <span *ngIf="selectedGroupByValue" class="group-by-badge"></span>
                    </span>
                    <app-filters [listCols]="enabledListCols" [selectedParentModule]="{name: objectType, objectId: objectTypeId, channelId: channelId}" (applyFiltersColumns)="applyFilters($event)"></app-filters>
                    <div *ngIf="activityLogGroupList?.length > 0" style="float: right; margin: 2px 5px 0px 5px;">
                        <button pButton size="small" type="button" [label]="expandCollapseText" (click)="expanAllActivities()" class="p-mr-2"></button>
                        <!-- <button pButton size="small" type="button" label="Collapse All" (click)="collapseAllActivities()"></button> -->
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <p-overlayPanel #groupby [showCloseIcon]="true" [style]="{width: '300px'}">
        <ng-template pTemplate>
            <label>Group By</label>
            <p-dropdown [options]="enabledListCols" class="panelDD" [filter]="true" [(ngModel)]="selectedGroupBy" optionLabel="name" placeholder="Select Field">
            </p-dropdown>
            <div class="p-text-right p-mt-2">
                <p-button label="Reset" class="p-button-secondary p-mt-2 p-mr-2" (click)="resetGroup(true);groupby.hide()" [disabled]="!selectedGroupBy"></p-button>
                <p-button label="Apply" class="p-mt-2" (onClick)="applyGroup();groupby.hide()" [disabled]="!selectedGroupBy"></p-button>
            </div>
        </ng-template>
    </p-overlayPanel>

    <div *ngIf="loadingActivityLogs" class="p-d-flex p-ai-center p-jc-center p-mt-3" [style]="{height: '40px'}">
        <p-progressSpinner styleClass="activity-custom-spinner" animationDuration=".5s"></p-progressSpinner>
    </div>

    <div *ngIf="!loadingActivityLogs && selectedGroupByValue" class="p-mt-1 activity-timeline-wrapper">
        <div class="timeline" *ngFor="let stageDetails of activityLogGroupList">
            <!-- <div class="timeline-separator">
                <div class="timeline-marker" [ngStyle]="{ 'border-color': 'gray' }"></div>
                <div class="timeline-connector" [ngStyle]="{ 'height': '100%', 'background-color': 'gray' }"></div>
            </div> -->
            <div class="timeline-right">
                <h6 class="timeline-stage-info">
                    <button type="button" pButton pRipple
                        class="p-button-text p-button-rounded p-button-plain group-expand-button"
                        (click)="toogleTimelineActivity(stageDetails)"
                        [icon]="stageDetails?.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                    </button>
                    <div class="timeline-stage">
                        {{ selectedGroupByValue.name }} - {{stageDetails.groupByValue||'NA'}} ({{stageDetails.activities?.length||0}})
                    </div>
                    <ng-container *ngIf="stageDetails?.activityCounts?.length>0">
                        <div class="timeline-activity-counts" [ngClass]="{'activity-count-filter-active': stageDetails?.filteredCounts}">
                            <ng-container *ngFor="let activityCount of stageDetails?.activityCounts">
                                <div (click)="filterActivitiesByCount(stageDetails,activityCount)" class="activity-icon cursor-pointer {{activityCount.colorClass}} p-shadow-3" [ngClass]="{'activity-count-filter': stageDetails?.filteredCounts?.id==activityCount.id}" tooltipPosition="top" [pTooltip]="activityCount?.activityName">
                                    <span *ngIf="!(activityCount.subTypes.length>0 && ['Inbound Call','Outbound Call'].includes(activityCount.subTypes[0]))" [class]="activityCount.icon"></span>
                                    <img [src]="assestBaseUrl + 'icons/incoming-call.png'" alt="incomingCall" style="width: 12px;" *ngIf="activityCount.subTypes.length>0 && activityCount.subTypes[0] == 'Inbound Call'" />
                                    <img [src]="assestBaseUrl + 'icons/outgoing-call.png'" alt="outgoingCall" style="width: 12px;" *ngIf="activityCount.subTypes.length>0 && activityCount.subTypes[0] == 'Outbound Call'" />
                                    <span class="activity-count">{{ activityCount.counts }}</span>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </h6>
                <div class="timeline-activity p-pb-2" [ngClass]="{'p-d-none': !stageDetails?.expanded}">
                    <app-shared-activity-list-template
                        [channelId]="channelId"
                        [selectedObject]="selectedObject"
                        [objectId]="objectId"
                        [objectTypeId]="objectTypeId"
                        [objectType]="objectType"
                        [contacts]="contacts"
                        [selectedObjectStages]="selectedObjectStages"
                        [isViewMode]="isViewMode"
                        [allActivityLogs]="stageDetails.activities">
                    </app-shared-activity-list-template>
                </div>

            </div>
        </div>
    </div>

    <div *ngIf="!loadingActivityLogs && !selectedGroupByValue" class="timeline">
        <app-shared-activity-list-template
            class="timeline-right"
            [channelId]="channelId"
            [selectedObject]="selectedObject"
            [objectId]="objectId"
            [objectTypeId]="objectTypeId"
            [objectType]="objectType"
            [contacts]="contacts"
            [selectedObjectStages]="selectedObjectStages"
            [isViewMode]="isViewMode"
            [allActivityLogs]="activityLogList">
        </app-shared-activity-list-template>
    </div>


    <!-- <div class="p-text-center loadmoreWrapper">
        <button pButton type="button" (click)="loadMore()" class="p-button-raised p-button-rounded" label="Load More"></button>
    </div> -->
</p-dialog>
